/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import { EXCLUDE_REPORT_SECTIONS } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import { Field, FormGroup } from '#components/pages/Models/Model/support/form/index.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const ReportOptionsSection = ({
  fieldsByName,
  form,
  heading,
  onBack,
  onNext,
}: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    <p>
      All sections are included by default — uncheck any you&apos;d like to leave out of the report.
    </p>
    <Form noValidate>
      <FormGroup form={form} fields={[EXCLUDE_REPORT_SECTIONS]}>
        <Field field={fieldsByName[EXCLUDE_REPORT_SECTIONS]} />
      </FormGroup>
      <BackButton onClick={onBack} />
      <NextButton onClick={onNext} />
    </Form>
  </div>
);

export default ReportOptionsSection;
